import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { siteInfo } from '@/mocks/articles';

const features = [
  {
    icon: 'ri-speed-up-line',
    title: '最快爆料速度',
    description: '7x24小时全天候监控全网爆料动态，确保吃瓜群众第一时间获取最新资讯，平均领先同行30分钟发布。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '信息三重核验',
    description: '每一条爆料均经过编辑团队的多方交叉验证，确保信息真实可靠，拒绝虚假谣言和恶意中伤。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '保护投稿隐私',
    description: '严格的匿名投稿机制与信息加密技术，全方位保护爆料人隐私安全，让知情人敢于说出真相。',
  },
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '黑料吃瓜网是做什么的？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '黑料吃瓜网是国内领先的娱乐资讯聚合平台，汇聚51黑料吃瓜、91黑料吃瓜、网曝一区二区等热门入口，实时更新全网独家网红黑料、明星塌房现场与每日吃瓜爆料视频。',
      },
    },
    {
      '@type': 'Question',
      name: '黑料吃瓜网成立于什么时候？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: `黑料吃瓜网成立于${siteInfo.founded}年，经过多年发展已成为国内最具影响力的娱乐爆料平台之一，累计发布爆料超过${siteInfo.articlesCount}条，日均访问量达${siteInfo.dailyVisitors}。`,
      },
    },
    {
      '@type': 'Question',
      name: '如何向黑料吃瓜网投稿？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过发送邮件至 tips@heiliaochigua.com 进行匿名投稿。我们采用严格的匿名投稿机制与信息加密技术，全方位保护爆料人隐私安全。',
      },
    },
    {
      '@type': 'Question',
      name: '黑料吃瓜网的内容如何保证真实性？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '每一条爆料均经过编辑团队的多方交叉验证，确保信息真实可靠。我们拒绝虚假谣言和恶意中伤，致力于为吃瓜群众提供最真实的娱乐资讯。',
      },
    },
    {
      '@type': 'Question',
      name: '如何与黑料吃瓜网进行商务合作？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '商务合作请联系 biz@heiliaochigua.com，我们将在48小时内回复。黑料吃瓜网日均访问量超过850万，是品牌推广和流量合作的理想平台。',
      },
    },
  ],
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: 'https://www.heiliaochigua.com',
  description: siteInfo.description,
  foundingDate: siteInfo.founded,
  slogan: siteInfo.slogan,
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'feedback@heiliaochigua.com',
  },
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `关于${siteInfo.name}`,
  description: `${siteInfo.name}品牌介绍 — ${siteInfo.description}`,
  url: 'https://www.heiliaochigua.com/about',
  isPartOf: {
    '@type': 'WebSite',
    name: siteInfo.name,
    url: 'https://www.heiliaochigua.com',
  },
};

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full min-h-[450px] md:min-h-[550px] flex flex-col">
          <div className="absolute inset-0 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20multiple%20screens%20displaying%20trending%20news%2C%20warm%20ambient%20lighting%2C%20professional%20yet%20dynamic%20atmosphere%2C%20editorial%20office%20with%20journalists%20working%2C%20dramatic%20shadows%2C%20cinematic%20photography%20style%2C%20dark%20wood%20furniture%2C%20red%20accent%20details&width=1920&height=800&seq=about-hero-2026&orientation=landscape"
              alt="关于黑料吃瓜网"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          </div>

          <div className="relative z-10 flex-1 flex items-center">
            <div className="w-full px-4 md:px-6">
              <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
                <div className="lg:w-[60%] pt-16 md:pt-20">
                  <h1 className="text-4xl sm:text-5xl md:text-6xl font-black font-heading text-white leading-tight tracking-tight">
                    <span className="block">关于</span>
                    <span className="block text-primary-400">黑料吃瓜网</span>
                    <span className="block">一手大瓜立刻开吃</span>
                  </h1>
                </div>
                <div className="lg:w-[40%] pt-0 lg:pt-24 pb-8">
                  <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-md">
                    黑料吃瓜网成立于{siteInfo.founded}年，是国内领先的娱乐资讯聚合平台。
                    我们致力于为每一位吃瓜群众提供最快、最全、最真实的娱乐爆料内容。
                  </p>
                  <Link
                    to="/category/mengliao"
                    className="inline-flex items-center gap-2 px-8 py-3 text-base font-semibold rounded-full border-2 border-white/60 text-white hover:bg-white/10 hover:border-white transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    立即开吃
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row items-start gap-10">
              <div className="lg:w-[40%]">
                <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-2">
                  品牌故事
                </p>
              </div>
              <div className="lg:w-[60%]">
                <p className="text-lg md:text-xl text-foreground-700 leading-relaxed mb-6">
                  黑料吃瓜网的创立源于一个简单的想法：让每一个吃瓜群众都能在第一时间吃上最新鲜的"瓜"。
                  在信息爆炸的时代，各种娱乐爆料真假难辨、来源混乱，读者往往需要花大量时间去筛选和验证。
                </p>
                <p className="text-lg md:text-xl text-foreground-700 leading-relaxed mb-6">
                  我们的编辑团队由一群资深娱乐记者和互联网内容运营专家组成，拥有多年的行业经验
                  和广泛的人脉资源。通过"51黑料吃瓜""91黑料吃瓜""网曝一区二区"等多个内容矩阵，
                  我们为读者提供全方位、多维度的娱乐资讯体验。
                </p>
                <p className="text-lg md:text-xl text-foreground-700 leading-relaxed">
                  让爆料不再枯燥，让吃瓜成为一门艺术。这，就是黑料吃瓜网存在的意义。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="text-center">
                <p className="text-4xl md:text-5xl font-black font-heading text-foreground-950 mb-2">
                  {siteInfo.founded}+
                </p>
                <p className="text-sm text-foreground-500">创始年份</p>
              </div>
              <div className="text-center">
                <p className="text-4xl md:text-5xl font-black font-heading text-foreground-950 mb-2">
                  {siteInfo.articlesCount}
                </p>
                <p className="text-sm text-foreground-500">累计爆料</p>
              </div>
              <div className="text-center">
                <p className="text-4xl md:text-5xl font-black font-heading text-foreground-950 mb-2">
                  {siteInfo.userSatisfaction}%
                </p>
                <p className="text-sm text-foreground-500">用户满意度</p>
              </div>
              <div className="text-center">
                <p className="text-4xl md:text-5xl font-black font-heading text-foreground-950 mb-2">
                  {siteInfo.dailyVisitors}
                </p>
                <p className="text-sm text-foreground-500">日均访问量</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3 text-center">
              为什么选择我们
            </p>
            <h2 className="text-3xl md:text-5xl font-black font-heading text-foreground-950 text-center mb-12">
              吃瓜群众的首选平台
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {features.map((feat) => (
                <div key={feat.title} className="bg-background-50 rounded-xl p-6 md:p-8">
                  <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 mb-5">
                    <i className={`${feat.icon} text-2xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold font-heading text-foreground-950 mb-3">
                    {feat.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {feat.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-50">
          <div className="px-4 md:px-6 max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-5xl font-black font-heading text-foreground-950 mb-4">
              联系黑料吃瓜网
            </h2>
            <p className="text-base md:text-lg text-foreground-600 mb-8">
              商务合作、内容投稿、意见反馈，欢迎通过以下方式联系我们
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10">
              <div className="bg-background-100 rounded-xl p-6 text-left">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mb-4">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-bold font-heading text-foreground-950 mb-1">商务合作</h3>
                <p className="text-sm text-foreground-600">biz@heiliaochigua.com</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 text-left">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 mb-4">
                  <i className="ri-send-plane-line text-xl"></i>
                </div>
                <h3 className="font-bold font-heading text-foreground-950 mb-1">内容投稿</h3>
                <p className="text-sm text-foreground-600">tips@heiliaochigua.com</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 text-left">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-50 text-secondary-600 mb-4">
                  <i className="ri-customer-service-line text-xl"></i>
                </div>
                <h3 className="font-bold font-heading text-foreground-950 mb-1">用户反馈</h3>
                <p className="text-sm text-foreground-600">feedback@heiliaochigua.com</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 text-left">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 mb-4">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h3 className="font-bold font-heading text-foreground-950 mb-1">公司地址</h3>
                <p className="text-sm text-foreground-600">北京市朝阳区建国路88号SOHO现代城</p>
              </div>
            </div>

            <Link
              to="/"
              className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-semibold rounded-full bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              商务合作
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}